/*
    Number of results shown per browse results page
*/
export const RESULTS_PER_PAGE = 10;

export const PAGE_SIZES = [10, 20, 30];
